enum IdentificacaoParticipante {
  CODIGO = '1',
  DOCUMENTO = '2'
}

export default IdentificacaoParticipante

